import Checkbox from '@rio-cloud/rio-uikit/Checkbox'; // todo: move it into the abstraction layer /components
import NoData from '@rio-cloud/rio-uikit/NoData';

import './_styles.scss';

interface Props {
    vin: string;
    name?: string | null;
    licensePlate?: string | null;
    owner?: string | null;
    active?: boolean;
    onChange(vin: string): void;
}

const SystemFleetsFormTableRow = ({ vin, name, licensePlate, owner, active, onChange }: Props) => {
    const vehicleName = name ?? <NoData text='No data' className='SystemFleetsFormTableRow__noData' />;
    const vehicleLicensePlate = licensePlate ?? <NoData text='No data' className='SystemFleetsFormTableRow__noData' />;
    const vehicleOwner = owner ?? <NoData text='No data' className='SystemFleetsFormTableRow__noData' />;

    return (
        <tr className='SystemFleetsFormTableRow' data-testid={`select-vehicles-table-row-${vin}`}>
            <td className='SystemFleetsFormTableRow__column'>
                <Checkbox
                    onChange={() => onChange(vin)}
                    checked={active}
                    inline
                    className='SystemFleetsFormTableRow__checkbox'
                />
            </td>
            <td data-testid='available-vehicles-row-vehicle-name' className='SystemFleetsFormTableRow__column'>
                {vehicleName}
            </td>
            <td data-testid='available-vehicles-row-vehicle-vin' className='SystemFleetsFormTableRow__column'>
                {vin}
            </td>
            <td data-testid='available-vehicles-row-license-plate' className='SystemFleetsFormTableRow__column'>
                {vehicleLicensePlate}
            </td>
            <td data-testid='available-vehicles-row-vehicle-owner' className='SystemFleetsFormTableRow__column'>
                {vehicleOwner}
            </td>
        </tr>
    );
};

export default SystemFleetsFormTableRow;
